const URL_PATTERN = /((https?:\/\/)?(www\.)?[\w-]+\.[a-z]+(\.[a-z]+)?(\/\S*)?)/gi;

export const extractFirstUrl = (value = '') => {
  const match = String(value || '').match(URL_PATTERN);
  if (!match?.length) {
    return '';
  }

  const url = match[0];
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

export const normalizeLinkPreview = (preview = {}) => {
  const url = preview.url || preview.finalUrl || preview.link || '';

  if (!url) {
    return null;
  }

  return {
    url,
    title: preview.title || preview.siteName || url,
    description: preview.description || '',
    image: preview.image || preview.images?.[0] || '',
    mediaType: preview.mediaType || preview.contentType || '',
    siteName: preview.siteName || '',
  };
};

export const getYouTubeEmbedUrl = (rawUrl = '') => {
  if (!rawUrl) {
    return '';
  }

  try {
    const parsedUrl = new URL(rawUrl);
    const hostname = parsedUrl.hostname.replace(/^www\./, '').toLowerCase();
    let videoId = '';

    if (hostname === 'youtu.be') {
      videoId = parsedUrl.pathname.split('/').filter(Boolean)[0] || '';
    }

    if (hostname === 'youtube.com' || hostname === 'm.youtube.com' || hostname === 'music.youtube.com') {
      if (parsedUrl.pathname.startsWith('/watch')) {
        videoId = parsedUrl.searchParams.get('v') || '';
      } else if (parsedUrl.pathname.startsWith('/shorts/') || parsedUrl.pathname.startsWith('/embed/')) {
        videoId = parsedUrl.pathname.split('/').filter(Boolean)[1] || '';
      }
    }

    return videoId ? `https://www.youtube.com/embed/${encodeURIComponent(videoId)}` : '';
  } catch (error) {
    return '';
  }
};
